import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/crm/inquiry/";

export function getInquiriesFromEmail() {
  return http.get(apiEndpoint);
}

export function getInquiryDetail(inquiryID) {
  return http.get(apiEndpoint + "inquiry-detail/" + inquiryID);
}

export function blockEmail(email) {
  return http.post(apiEndpoint + "block-email", { email });
}

export function moveInquiryToJunk(inquiry) {
  return http.post(apiEndpoint + "move-inquiry-junk", inquiry);
}
